export const MOBILE = 600;
export const MAX_MOBILE = 767;
export const TABLET = 768;
export const LAPTOP = 1024;
export const DESKTOP = 1200;
export const isBrowserMobileView = (width) => width < TABLET;
export const isBrowserTabletView = (width) => width >= TABLET && width < LAPTOP;
export const isBrowserTouchView = (width) => width <= LAPTOP;
export const isBrowserLaptopView = (width) => width >= LAPTOP && width < DESKTOP;
export const isBrowserDesktopView = (width) => width >= DESKTOP;
//# sourceMappingURL=breakpoints.js.map